import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { IUnifiedFilter } from 'src/contexts/SearchFilterContext';

import { ClassifiedPurchase } from '../classified-purchase/ClassifiedPurchase';
import { ClassifiedRoundSales } from '../classified-round-sales/ClassifiedRoundSales';
import { createComment } from '../comment/Comment';
import { createCustomer } from '../customer/Customer';
import { createDept } from '../dept/Dept';
import { IFcChartFilter } from '../fc-chart/FcChart';
import { createMng } from '../mng/Mng';
import { createModelCode } from '../model-code/ModelCode';
import { createPagination } from '../pagination/Pagination';
import { createPartner } from '../partner/Partner';
import { PurchaseList } from '../purchase-list/PurchaseList';
import { createSimpleUser } from '../user/SimpleUser';
import { createUserDefaultModel } from '../user/user';

import { OrderList } from './OrderList';
import { RoundSalesList } from './RoundSalesList';

/**
 * # Project
 *
 * Project을 설명하세요.
 */
export const Project = types
  .model('Project')
  // --------------------------------------------------------------------------
  .props({
    projectSid: types.optional(types.number, 0), // 프로젝트 아이디
    projectMngId: types.maybeNull(types.string), // 프로젝트 관리 아이디
    projectTypeCd: createModelCode() || types.number, // 프로젝트 유형 <코드-2001>
    projectTypeCdList: types.maybeNull(types.optional(types.array(createModelCode()), [])),
    mngList: types.maybeNull(types.optional(types.array(createMng()), [])),
    projectNm: types.maybeNull(types.optional(types.string, '')), // 프로젝트 이름
    // deprtCd: types.maybeNull(createModelCode()), // 본부 코드 <동적코드-100001>
    deptSid: types.maybeNull(types.optional(types.number, 0)),
    dept: types.maybeNull(createDept()), // createModelCode(),
    severityCd: types.maybeNull(createModelCode()), // 심각도 코드 <코드-2002>
    reportYn: types.maybeNull(types.optional(types.boolean, true)), //
    progYn: types.maybeNull(types.optional(types.boolean, true)), //
    bo: types.maybeNull(createSimpleUser()), // BO
    pm: types.maybeNull(createSimpleUser()), // PM
    customerCmpy: types.maybeNull(createCustomer()), // types.maybeNull(types.string), // 고객사
    cstmrRelMngNm: types.maybeNull(types.string), // 고객사 담당자 이름
    cstmrRelMngPh: types.maybeNull(types.string), // 고객사 담당자 연락처
    cstmrRelMngEmail: types.maybeNull(types.string), // 고객사 담당자 이메일
    contractCmpy: types.maybeNull(createCustomer()), // types.maybeNull(types.string), // 계약사
    cntrctCmpy: types.maybeNull(types.string), // 계약사
    cntrctDay: types.maybeNull(types.number), //
    startDay: types.maybeNull(types.number), //
    endDay: types.maybeNull(types.number), //
    bzStepCd: types.maybeNull(createModelCode() || types.number), // 영업단계 <코드-2003>
    orderPrcnt: types.maybeNull(types.number), // 수주확률
    orderAmt: types.maybeNull(types.number), // 수주금액
    orderMargin: types.maybeNull(types.number), // 예상수주마진
    marginPrcnt: types.maybeNull(types.number), // 예상수주마진
    orderDay: types.maybeNull(types.number), // 수주일
    salesAmt: types.maybeNull(types.number), // 매출금액
    salesMargin: types.maybeNull(types.number), // 예상매출마진
    orderFCauses: types.maybeNull(createModelCode() || types.number), // 실주 원인
    orderSCauses: types.maybeNull(createModelCode() || types.number), // 수주 원인
    orderList: types.maybeNull(types.array(OrderList)), //
    // classifiedOrder: types.maybeNull(createOrderList()), // 프로젝트 타입별 수주
    roundSalesList: types.maybeNull(types.array(RoundSalesList)), //
    classifiedRoundSales: types.maybeNull(types.array(ClassifiedRoundSales)), // 프로젝트 타입별 매출
    summary: types.maybeNull(types.string), // 요약(상황설명)
    descr: types.maybeNull(types.string), // 기존 descr -> 기타메모
    regDt: types.maybeNull(types.optional(types.number, 0)), //
    updDt: types.maybeNull(types.optional(types.number, 0)), //
    regUser: types.maybeNull(createUserDefaultModel()), //
    updUser: types.maybeNull(createUserDefaultModel()), //

    // 24.11.20 추가
    boSid: types.maybeNull(types.number), // BO sid
    pmSid: types.maybeNull(types.number), // PM sid
    rmnngSales: types.maybeNull(types.number), // 수주잔고(남은 매출금액)
    purchaseAmt: types.maybeNull(types.number), // 총 매입금액
    totalLaborCost: types.maybeNull(types.number), // 매입(인건비)
    totalGoodsCost: types.maybeNull(types.number), // 매입(물품)
    purchaseList: types.maybeNull(types.array(PurchaseList)), // 매입리스트
    classifiedPurchase: types.maybeNull(types.array(ClassifiedPurchase)), // 프로젝트 타입별 매입
    recentComment: types.maybeNull(types.optional(types.string, '')), // 댓글(변동내역)
    comments: types.maybeNull(types.optional(types.array(createComment()), [])), // 댓글(변동내역)
    // 24.12.11 추가
    newStatusCd: types.maybeNull(createModelCode() || types.number),
    ongoingCd: types.maybeNull(createModelCode() || types.number),
    esmCode: types.maybeNull(types.string), // ESM 코드
    bizMngCode: types.maybeNull(types.string), // 사업관리코드
    bizDraftNo: types.maybeNull(types.string), // 사업기안번호
    uuid: types.maybeNull(types.string), // UUID
    orgId: types.maybeNull(types.string), // 조직 ID
    salesRep: types.maybeNull(createSimpleUser()), // 영업담당자
    msp: types.maybeNull(createPartner()), // 파트너사 (MSP/협력)
    ap: types.maybeNull(createPartner()), // 파트너사 (AP/일반)
    billCriteriaCd: types.maybeNull(createModelCode() || types.number), // 청구기준
    billPeriodCd: types.maybeNull(createModelCode() || types.number), // 청구시기
    billChargeCd: types.maybeNull(createModelCode() || types.number),
    paymentInfo: types.maybeNull(types.string), // 수금정보
    quotationFile: types.maybeNull(types.string), // 견적서 파일
    quotationFilePath: types.maybeNull(types.string), // 견적서 파일경로
    additionalFiles: types.maybeNull(types.array(types.maybeNull(types.string))), // 첨부파일
    additionalFilePaths: types.maybeNull(types.array(types.maybeNull(types.string))), // 첨부파일경로

    pagination: createPagination(), // 페이지 정보

    // Data Grid 표시용
    cstmrCmpy: types.maybeNull(types.string), // 고객사
    firstPayment: types.maybeNull(types.number), // 선급금
    firstIssueDay: types.maybeNull(types.number), // 선급금 발행일
    // firstExchgRate: types.maybeNull(types.number), //
    // firstCurrencyCd: types.maybeNull(createModelCode() || types.number), //
    middlePayment: types.maybeNull(types.number), // 중도금
    middleIssueDay: types.maybeNull(types.number), // 중도금 발행일
    // middleExchgRate: types.maybeNull(types.number), //
    // middleCurrencyCd: types.maybeNull(createModelCode() || types.number), //
    lastPayment: types.maybeNull(types.number), // 잔금
    lastIssueDay: types.maybeNull(types.number), // 잔금 발행일
    // lastExchgRate: types.maybeNull(types.number), //
    // lastCurrencyCd: types.maybeNull(createModelCode() || types.number), //
    monthlySales: types.maybeNull(types.array(types.number)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model project --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IProject;
      (Object.keys(newProps) as TProjectKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TProject = Instance<typeof Project>;
type TProjectSnapshot = SnapshotOut<typeof Project>;

export interface IProject extends TProject {}
export type TProjectKeys = keyof TProjectSnapshot & string;
export interface IProjectSnapshot extends TProjectSnapshot {}
export const createProject = () => types.optional(Project, {} as TProject);

export interface IProjectFilter extends IUnifiedFilter {
  // deprtCd?: number;
  deptSid?: number;
  pmSid?: number;
  bzStepCd?: number;
  sortBy?: string;
  // text?: string;
  severityCdList?: string;
  page?: number;
  size?: number;
  searchSidList?: string | number[];
  startDate?: number;
  endDate?: number;
  dataType?: 'order' | 'sales' | 'margin';
  projectTypeCd?: number;
  exceptProjectTypeCdList?: number[] | null;
  baseDate?: number;
  orderSCauses?: number;
  orderFCauses?: number;
  // orderPrcnt?: number;
  // minPrice?: number;
  // maxPrice?: number;
}

export type TProjectFilter = IProjectFilter;
